module.exports = __webpack_public_path__ + "images/旅悦好物全景_03.jpg?v=eea8b7bf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/lvyue3/旅悦好物全景_03.jpg
 ** module id = 131
 ** module chunks = 1 2
 **/